const deviceFilter = {
  status: 'all'
}

var any_dc_device = false

function getAnyDcDevice() {
  return any_dc_device
}

function setAnyDcDevice(value) {
  any_dc_device = value
}

const checkStatus = function (vnode) {
  let result = ''
  let pwThreshold = 7
  console.log('POWER', vnode.current * vnode.voltage)
  if (vnode.maintenance) {
    result = 'maintenance'
  } else if (vnode.offlineStatus === 'offline') {
    result = 'offline'
  } else if (vnode.error_status) {
    result = 'error'
  } else if ((typeof vnode.statuson !== 'undefined') && (vnode.statuson)) {
    result = 'on'
  } else if ((typeof vnode.current !== 'undefined') && (typeof vnode.voltage !== 'undefined') && (vnode.current * vnode.voltage >= pwThreshold)) {
    result = 'on'
  } else if ((typeof vnode.current !== 'undefined') && (vnode.current * 1 >= 0.06)) {
    result = 'on'
    // } else if ((typeof vnode.brightness !== 'undefined' ) && (vnode.brightness>0.0000001)) {
    //   result = 'on'
  } else {
    result = 'off'
  }
  return result
}
const getRssiCategory = function (rssi) {
  if (typeof rssi === 'undefined' || rssi === null || rssi === '' || isNaN(rssi)) return ''
  const val = parseFloat(rssi)
  if (val >= -80) {
    return 'Sangat Bagus'
  } else if (val >= -100) {
    return 'Bagus'
  } else if (val >= -115) {
    return 'Sedang'
  } else {
    return 'Lemah'
  }
}

const getSnrCategory = function (snr) {
  if (typeof snr === 'undefined' || snr === null || snr === '' || isNaN(snr)) return ''
  const val = parseFloat(snr)
  if (val > 5) {
    return 'Sangat Bagus'
  } else if (val >= 0) {
    return 'Bagus'
  } else if (val >= -10) {
    return 'Sedang'
  } else {
    return 'Lemah'
  }
}

const formatRssi = function (rssi) {
  if (typeof rssi === 'undefined' || rssi === null || rssi === '' || isNaN(rssi)) return '-'
  const val = parseFloat(rssi)
  const category = getRssiCategory(val)
  const formattedRssi = Math.round(val * 10) / 10
  return category ? `${formattedRssi} dBm (${category})` : `${formattedRssi} dBm`
}

const formatSnr = function (snr) {
  if (typeof snr === 'undefined' || snr === null || snr === '' || isNaN(snr)) return '-'
  const val = parseFloat(snr)
  const category = getSnrCategory(val)
  const formattedSnr = Math.round(val * 10) / 10
  const snrStr = formattedSnr > 0 ? `+${formattedSnr}` : `${formattedSnr}`
  return category ? `${snrStr} dB (${category})` : `${snrStr} dB`
}

const formatSpreading = function (sf) {
  if (typeof sf === 'undefined' || sf === null || sf === '' || isNaN(sf)) return '-'
  return `SF${sf}`
}

const checkRssiStrength = function (vnode) {
  let result = 'other'
  if (typeof vnode.rssi !== 'undefined' && vnode.rssi !== null && !isNaN(vnode.rssi)) {
    const category = getRssiCategory(vnode.rssi)
    if (category) {
      result = category.toLowerCase()
    }
  }
  return result
}

const calcLoad = function (vnode) {
  let result = undefined
  if ((typeof vnode.current !== 'undefined') && (typeof vnode.voltage !== 'undefined')) {
    result = vnode.current * vnode.voltage
    if (isNaN(result)) {
      result = undefined
    }
  }
  return result
}

// konversi huruf besar di awal kata
const capitalize = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
  // return str+'***'
}


// // konversi snake case ke caption case
// const snakeToCamel = function (str) { 
//   let xstr = str.replace(/([-_][a-z])/ig, ($1) => {
//     let vstr = $1.toUpperCase()
//         .replace('-', ' ')
//         .replace('_', ' ')
//     return vstr
//   });
//   return capitalize(xstr)
// }

// const convertTODesc = function (str) {
//   const data = {
//     'high': 'Tinggi',
//     'medium': 'Sedang',
//     'other': 'Tidak diketahui',
//   }
// }

const inSearch = function (vnode, deviceFilter) {
  // console.log(vnode, deviceFilter)


  // return false
  if (deviceFilter.status === 'all') {
    console.log('filter all', vnode.status, true)
    return true
  } else if (deviceFilter.status === 'error') {
    if (vnode.status === 'error') {
      if (deviceFilter.subStatus === 'all') {
        return true
      } else if (deviceFilter.subStatus === 'no_current_data') {
        if (vnode.error_status === 'no_current_data') {
          return true
        } else {
          return false
        }
      } else if (deviceFilter.subStatus === 'other') {
        if (vnode.error_status === 'no_current_data') {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    } else {
      console.log('filter ' + deviceFilter.status, vnode.status, false)
      return false
    }
  } else if (deviceFilter.status === vnode.status) {
    console.log('filter ' + deviceFilter.status, vnode.status, true)
    return true
  } else {
    console.log('filter ' + deviceFilter.status, vnode.status, false)
    return false
  }
}

const calculateChildren = function (vParent, searchId) {
  let vcount = 0
  let vcountOn = 0
  let vcountOff = 0
  let vcountError = 0
  let vcountMaint = 0
  let vcountOffline = 0
  let vtotalPower = 0
  let vcountVoltage = 0
  let vtotalVoltage = 0
  let vtotalCurrent = 0
  let vusageToday = 0
  let vusageMonth = 0
  let vrpToday = 0
  let vrpMonth = 0
  let vChildren = vParent.children
  let xlist = []
  let vselected = null
  for (let i = 0; i < vChildren.length; i++) {
    let vnode = vChildren[i]
    if (vnode.type === 'device' && vnode.devicetype === 'pju-dc') {
      setAnyDcDevice(true)
      console.log('sssssss', vnode, any_dc_device)
    }
    if (vnode.id == searchId) {
      vselected = vnode
    }
    if (vnode.type === 'device') {

      let vOffline = checkOfflineStatus(vnode)
      vnode.offlineStatus = vOffline.offlineStatus
      vnode['onlineStatus'] = vOffline.onlineStatus
      vnode['dataAge'] = vOffline.dataAge

      let vErr = checkErrorStatus(vnode)
      console.log('Err Status', vErr)
      if (vErr) {
        vnode.error_status = vErr.errorname
        vnode.error_reason = vErr.message
      } else {
        delete vnode.error_status
        delete vnode.error_reason
      }
      vnode.rssi_strength = checkRssiStrength(vnode)
      vnode.rssi_strength_desc = capitalize(vnode.rssi_strength)
      vnode.rssi_desc = formatRssi(vnode.rssi)
      vnode.snr_desc = formatSnr(vnode.snr)
      vnode.spreading_desc = formatSpreading(vnode.spreading)
      vnode.status = checkStatus(vnode)
      if (vnode.offlineStatus === 'offline') {
        vnode.power = 0
        vnode.current = 0
        vnode.voltage = 0
        vnode.brightness = 0
        vnode.rssi_strength = 'offline'
        vnode.rssi_strength_desc = 'Offline'
        vnode.rssi_desc = 'Offline'
        vnode.snr_desc = 'Offline'
        vnode.spreading_desc = 'Offline'
      }
      if (inSearch(vnode, deviceFilter)) {
        vcount = vcount + 1

        if (vnode.status === 'on' || vnode.status === 'off') {
          if (typeof vnode.current !== 'undefined') {
            vtotalCurrent = vtotalCurrent + vnode.current * 1
          }
          if (typeof vnode.voltage !== 'undefined') {
            vcountVoltage = vcountVoltage + 1
            vtotalVoltage = vtotalVoltage + vnode.voltage * 1
          }
          if (typeof vnode.power !== 'undefined') {
            vtotalPower = vtotalPower + vnode.power * 1
          }

        }
        if (typeof vnode.usage_today !== 'undefined') {
          vusageToday = vusageToday + vnode.usage_today * 1
        }
        if (typeof vnode.usage_month !== 'undefined') {
          vusageMonth = vusageMonth + vnode.usage_month * 1
        }
        if (typeof vnode.rp_today !== 'undefined') {
          vrpToday = vrpToday + vnode.rp_today * 1
        }
        if (typeof vnode.rp_month !== 'undefined') {
          vrpMonth = vrpMonth + vnode.rp_month * 1
        }

        if (vnode.status === 'offline') {
          vcountOffline = vcountOffline + 1
          vnode.status_description = vnode.error_reason
          vnode.status_caption = 'Offline'
        } else if (vnode.status === 'maintenance') {
          vcountMaint = vcountMaint + 1
          vnode.status_description = vnode.maintenance_desc
          vnode.status_caption = 'Maintenance'
        } else if (vnode.status === 'error') {
          vcountError = vcountError + 1
          vnode.status_description = vnode.error_reason
          vnode.status_caption = 'Warning'
        } else if (vnode.status === 'on') {
          vcountOn = vcountOn + 1
          vnode.status_description = undefined
          vnode.status_caption = 'ON'
        } else if (vnode.status === 'off') {
          vcountOff = vcountOff + 1
          vnode.status_description = undefined
          vnode.status_caption = 'OFF'
        } else {
          vcountError = vcountError + 1
          vnode.status_description = undefined
          vnode.status_caption = ''
        }
        xlist.push(vnode)
      }
      // if (vErr || (vOffline.offlineStatus==='offline')) {
      //   vcountError = vcountError + 1
      //   vnode['lightstatus'] = false
      // } else {
      //   if (checkOnStatus(vnode)) {
      //     vcountOn = vcountOn + 1
      //     vnode['lightstatus'] = true
      //   } else {
      //     vcountOff = vcountOff + 1
      //     vnode['lightstatus'] = false
      //   }
      // }
      vnode.load = calcLoad(vnode)
    } else {
      if (vParent.name === 'Bandung') {
        console.log('xparent', vParent, xlist)
      }
      if (vnode.hasChildren) {
        let { count, countOn, countOff, countOffline, countMaint, countError, listDevices, selected,
          totalPower, countVoltage, totalVoltage, totalCurrent, usageToday, usageMonth, rpToday, rpMonth } = calculateChildren(vnode, searchId)
        xlist = xlist.concat(listDevices)
        let averageVoltage = 0
        if (countVoltage > 0) {
          averageVoltage = totalVoltage / countVoltage
        }
        vnode.info = {
          count: count, countOn: countOn, countMaint: countMaint, countOffline: countOffline,
          countOff: countOff, countError: countError, totalPower: totalPower, countVoltage: countVoltage,
          totalVoltage: totalVoltage, totalCurrent: totalCurrent, averageVoltage: averageVoltage,
          usage_today: usageToday, usage_month: usageMonth, rp_today: rpToday, rp_month: rpMonth
        }
        vnode.listDevices = listDevices
        vcount = vcount + count
        vcountOn = vcountOn + countOn
        vcountMaint = vcountMaint + countMaint
        vcountOff = vcountOff + countOff
        vcountOffline = vcountOffline + countOffline
        vcountError = vcountError + countError
        if (selected) {
          vselected = selected
        }
        vtotalPower = vtotalPower + totalPower
        vcountVoltage = vcountVoltage + countVoltage
        vtotalVoltage = vtotalVoltage + totalVoltage
        vtotalCurrent = vtotalCurrent + totalCurrent
        vusageToday = vusageToday + usageToday
        vusageMonth = vusageMonth + usageMonth
        vrpToday = vrpToday + rpToday
        vrpMonth = vrpMonth + rpMonth
      }

    }
  }
  return {
    count: vcount, countOn: vcountOn, countOff: vcountOff, countError: vcountError,
    countOffline: vcountOffline, countMaint: vcountMaint, listDevices: xlist, selected: vselected,
    totalPower: vtotalPower, countVoltage: vcountVoltage, totalVoltage: vtotalVoltage, totalCurrent: vtotalCurrent,
    usageToday: vusageToday, usageMonth: vusageMonth, rpToday: vrpToday, rpMonth: vrpMonth
  }
}

const calculateDeviceTree = function (deviceTree, searchId, statusMode, subStatus = '') {
  any_dc_device = false
  deviceFilter.status = statusMode
  deviceFilter.subStatus = subStatus
  console.log('calculateDeviceTree', statusMode, subStatus, deviceTree)
  let result = { count: 0, countOn: 0, countOff: 0, countOffline: 0, countError: 0 }
  if (typeof deviceTree.children !== 'undefined') {
    // const vChildren = deviceTree.children
    let { count, countOn, countOff, countMaint, countOffline, countError, listDevices, selected,
      totalPower, countVoltage, totalVoltage, totalCurrent, usageToday, usageMonth, rpToday, rpMonth } = calculateChildren(deviceTree, searchId)
    result = {
      count: count, countOn: countOn, countMaint: countMaint, countOffline: countOffline,
      countOff: countOff, countError: countError, selected: selected, totalPower: totalPower, countVoltage: countVoltage,
      totalVoltage: totalVoltage, totalCurrent: totalCurrent
    }
    if (typeof deviceTree.info === 'undefined') {
      deviceTree.info = {}
    }
    deviceTree.info.count = result.count
    deviceTree.info.countOn = result.countOn
    deviceTree.info.countOff = result.countOff
    deviceTree.info.countOffline = result.countOffline
    deviceTree.info.countMaint = result.countMaint
    deviceTree.info.countError = result.countError
    deviceTree.info.totalPower = result.totalPower
    deviceTree.info.totalCurrent = result.totalCurrent
    deviceTree.info.totalVoltage = result.totalVoltage
    deviceTree.info.usage_today = usageToday
    deviceTree.info.usage_month = usageMonth
    deviceTree.info.rp_today = rpToday
    deviceTree.info.rp_month = rpMonth
    let averageVoltage = 0
    if (result.countVoltage > 0) {
      averageVoltage = result.totalVoltage / result.countVoltage
    }
    deviceTree.info.averageVoltage = averageVoltage
    deviceTree.listDevices = listDevices
    if (deviceTree.info.count > 0) {
      deviceTree.info.percentOn = deviceTree.info.countOn / deviceTree.info.count * 100
    } else {
      deviceTree.info.percentOn = 0
    }
    console.log('xcalc count', count, countOn, countOff, countError, listDevices)
  }
  // console.log('ssss any data device', getAnyDcDevice())
  return { result: result, any_dc_device: getAnyDcDevice() }
  // return result
}

const checkOnStatus = function (vdata) {
  // if (vdata) {
  //   return true
  // }
  // return true
  if (vdata && (typeof vdata.current !== 'undefined')) {
    if (!(isNaN(vdata.current))) {
      let smallNumber = 0.000000001
      let vcurrent = vdata.current * 1
      if (vcurrent > smallNumber) {
        return true
      }
    }
  }
  return false
}

const checkDataAge = function (vdata) {
  // bila field waktu tidak ada maka umur data dianggap besar (default)
  // default menggunakan angka yg sangat besar (mis 1000 hari = 1000 * 24 * 3600)
  let result = 100 * 24 * 3600
  if ((typeof vdata !== 'undefined') && (typeof vdata.lastdata !== 'undefined') && vdata.lastdata !== null) {
    let ms = Date.now()
    let dateStr = vdata.lastdata
    // Handle format "YYYY-MM-DD HH:mm:ss" dengan mengganti spasi jadi 'T'
    if (typeof dateStr === 'string' && dateStr.includes(' ') && !dateStr.includes('T')) {
      dateStr = dateStr.replace(' ', 'T')
    }
    let xdate = new Date(dateStr).getTime();
    if (!isNaN(xdate)) {
      result = Math.floor((ms - xdate) / 1000)
    }
  }
  return result
}

const checkErrorStatus = function (vdata) {
  // error
  // - no data
  // - no current data
  // - broken (status relay on tapi current = 0)
  // - offline
  // kalau tidak error, return false
  if (typeof vdata === 'undefined') {
    return { errorname: 'no_data', message: 'No Data' }
  } else {
    // ada data error
    if (typeof vdata.error_status !== 'undefined' && vdata.error_status) {
      let err_stat = vdata.error_status
      let err_reason = 'Unknown Error'
      if (typeof vdata.error_reason !== 'undefined') {
        err_reason = vdata.error_reason
      }
      return { errorname: err_stat, message: err_reason }
    }
    // Bypass local broken/current data checks for offline devices
    if (vdata.offlineStatus === 'offline') {
      return false
    }
    // tidak ada data current
    if (typeof vdata.current === 'undefined') {
      return { errorname: 'no_current_data', message: 'No Current Data' }
    } else {
      if (typeof vdata.relaystatus !== 'undefined') {
        if (vdata.relaystatus === 'ON') {
          let statusOn = checkOnStatus(vdata)
          if (!statusOn) {
            return { errorname: 'broken', message: 'Lamp Broken. Relay: ON, Current: 0' }
          }

          // let smallNumber = 0.000000001
          // if (Math.abs(vdata.current * 1) < smallNumber) {
          //   return {errorname: 'broken', message: 'Lamp Broken'}
          // }
        }
      }
    }

  }
  return false
}

const formatInterval = function (seconds) {
  if (seconds < 60) {
    return seconds + ' sec'
  } else if (seconds < 3600) {
    let minutes = Math.floor(seconds / 60)
    return minutes + ' min'
  } else if (seconds < (24 * 3600)) {
    let hours = Math.floor(seconds / 3600)
    return hours + ' hours'
  } else if (seconds < (100 * 24 * 3600)) {
    let days = Math.floor(seconds / (24 * 3600))
    return days + ' days'
  } else {
    return '> 99 days'
  }
}

const checkOfflineStatus = function (vdata) {
  // let maxTime = 1 * 24 * 3600 // 24 jam
  let maxTime = 3600 * 2 // 2 jam
  let dataAge = checkDataAge(vdata)
  let interval = formatInterval(dataAge)
  if (dataAge > maxTime) {
    return { offlineStatus: 'offline', dataAge: interval }
  }
  return { offlineStatus: 'online', dataAge: interval }
}

const getDeviceItem = function (vchildren, vlist) {
  if (vchildren) {
    for (let i = 0; i < vchildren.length; i++) {
      let vitem = vchildren[i]
      if (vitem.type === 'device') {
        vlist.push(vitem)
      }
      if (vitem.children) {
        getDeviceItem(vitem.children, vlist)
      }
    }
  }
}
const extractDeviceListFromTree = function (vselected) {
  let result = []
  if (vselected.children) {
    getDeviceItem(vselected.children, result)
  }
  return result
}

export { calculateDeviceTree, checkErrorStatus, checkOnStatus, extractDeviceListFromTree, getAnyDcDevice, checkOfflineStatus, formatRssi, formatSnr, formatSpreading, getRssiCategory, getSnrCategory }